import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

const PRESET_COLORS = ['#1f3a5f','#ffffff','#111827','#f0ead0','#c8a84b','#e8d5a3','#4ade80','#60a5fa'];

/**
 * ClockSettingsStep — הגדרות שעון (צבע ספרות)
 * Props: { formData, onChange }
 */
const ClockSettingsStep = ({ formData, onChange }) => {
  const textColor = formData.textColor || '#1f3a5f';

  return (
    <Stack spacing={3} dir="rtl">
      <Box>
        <Typography sx={{ fontWeight: 600, color: '#111827', fontSize: '0.875rem', mb: 0.5 }}>
          צבע ספרות (שעונים דיגיטליים)
        </Typography>
        <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', mb: 1 }}>
          משפיע רק על תבניות "דיגיטלי שלם" ו"דיגיטלי גדול"
        </Typography>
        <Stack direction="row" spacing={0.75} flexWrap="wrap" gap={0.75} alignItems="center">
          {PRESET_COLORS.map(c => (
            <Box
              key={c}
              onClick={() => onChange({ textColor: c })}
              sx={{
                width: 28, height: 28, borderRadius: 1, bgcolor: c, cursor: 'pointer',
                border: textColor === c ? '2px solid #111827' : '1px solid #e5e7eb',
                transition: 'all 0.15s', '&:hover': { borderColor: '#9ca3af' },
                outline: c === '#ffffff' ? '1px solid #e5e7eb' : 'none',
              }}
            />
          ))}
          <Box
            component="label"
            title="צבע מותאם"
            sx={{
              width: 28, height: 28, borderRadius: 1, cursor: 'pointer', overflow: 'hidden',
              border: PRESET_COLORS.includes(textColor) ? '1px solid #e5e7eb' : '2px solid #111827',
              position: 'relative',
              background: 'linear-gradient(135deg, #f87171 0%, #facc15 25%, #4ade80 50%, #60a5fa 75%, #a78bfa 100%)',
              '&:hover': { borderColor: '#9ca3af' },
            }}
          >
            <Box
              component="input"
              type="color"
              value={textColor}
              onChange={(e) => onChange({ textColor: e.target.value })}
              sx={{ position: 'absolute', top: 0, left: 0, width: '200%', height: '200%', opacity: 0, cursor: 'pointer' }}
            />
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};

export default ClockSettingsStep;
